import React from "react";
import LoginLayout from "../LoginLayout/LoginLayout";

const LoginView = () => {
  return (
    <div>
      <LoginLayout data="login" />
    </div>
  );
};

export default LoginView;
